import { arrayIncludesUnknown } from '@hg-akademie-ban/vamos-viva-type-utils';
import { ExpandMore } from '@mui/icons-material';
import { IconButton, type Theme } from '@mui/material';
import {
  gridDetailPanelExpandedRowIdsSelector,
  gridDetailPanelExpandedRowsContentCacheSelector,
  type GridRenderCellParams,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-pro';
import { isValidElement } from 'react';

export const DataGridPanelToggle = (props: Pick<GridRenderCellParams, 'id' | 'value'>) => {
  const { id } = props;
  const apiRef = useGridApiContext();

  // To avoid calling ´getDetailPanelContent` all the time, the following selector
  // gives an object with the detail panel content for each row id.
  const contentCache = useGridSelector(apiRef, gridDetailPanelExpandedRowsContentCacheSelector);

  const expandedRowIds = useGridSelector(apiRef, gridDetailPanelExpandedRowIdsSelector);

  const isExpanded = expandedRowIds instanceof Set ? expandedRowIds.has(id) : arrayIncludesUnknown(expandedRowIds, id);

  // If the value is not a valid React element, it means that the row has no detail panel.
  const hasDetail = isValidElement(contentCache[id]);

  return (
    <IconButton
      size="small"
      tabIndex={-1}
      disabled={!hasDetail}
      aria-label={isExpanded ? 'Close' : 'Open'}
      color="primary"
      sx={{ marginTop: '-4px' }}
    >
      <ExpandMore
        sx={(theme: Theme) => ({
          transform: `rotateZ(${isExpanded ? 180 : 0}deg)`,
          transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
          }),
        })}
        fontSize="inherit"
        color="primary"
      />
    </IconButton>
  );
};
